import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, useState } from 'react';
import cn from 'classnames';
import './styles/Checkbox.scss';
function Checkbox(props, ref) {
    var _a = useState(false), focused = _a[0], setFocusedState = _a[1];
    var className = props.className, disabled = props.disabled, _b = props.error, error = _b === void 0 ? false : _b, value = props.value, name = props.name, label = props.label, checked = props.checked, indeterminate = props.indeterminate, onChange = props.onChange, _c = props.onFocus, onFocus = _c === void 0 ? function () { } : _c, _d = props.onBlur, onBlur = _d === void 0 ? function () { } : _d;
    var classNames = cn('Checkbox', className, {
        Checkbox_checked: checked,
        Checkbox_disabled: disabled,
        Checkbox_error: !disabled && error,
        Checkbox_focused: !disabled && focused,
        Checkbox_indeterminate: indeterminate
    });
    var inputProps = {
        name: name,
        value: value,
        disabled: disabled,
        checked: checked,
        indeterminate: indeterminate ? String(indeterminate) : undefined,
        onChange: onChange
    };
    var handleFocus = function (event) {
        onFocus(event);
        if (event.defaultPrevented)
            return;
        setFocusedState(true);
    };
    var handleBlur = function (event) {
        onBlur(event);
        if (event.defaultPrevented)
            return;
        setFocusedState(false);
    };
    return (React.createElement("label", { className: classNames },
        React.createElement("span", { className: "Checkbox__inputWrapper" },
            React.createElement("input", __assign({ ref: ref, className: "Checkbox__input", type: "checkbox", onFocus: handleFocus, onBlur: handleBlur }, inputProps)),
            React.createElement("span", { className: "Checkbox__inputAfter" })),
        label && React.createElement("span", { className: "Checkbox__label" }, label)));
}
/**
 * @version ../package.json
 */
export default forwardRef(Checkbox);
//# sourceMappingURL=Checkbox.js.map